/* src/app/features/distribuicao-limites-agentes/distribuicao-limites/distribuicao-limites.component.scss */
.d-flex.title1 {
  padding-right: 800px;
  font-weight: bold;
}
.d-flex.title2 {
  padding-right: 774px;
  font-weight: bold;
}
.label-verde {
  color: green;
}
/*# sourceMappingURL=distribuicao-limites.component.css.map */
